import type from "./action-type";
import * as Api from "api/api";

export const init = () => {
    return {
        type: type.INIT
    };
};

export const setGoodsCategoryList = payload => {
    return {
        type: type.SET_GOODS_CATEGORY_LIST,
        payload
    };
};

// 获取商品类别列表
export const fetchGoodsCategoryList = () => {
    return async f => {
        try {

            const nav = await Api.nav();

            let list = [];

            const {
                list: pddGoodsCategoryList,
                hasSelfCategory
            } = await Api.pddGoodsCategoryListByParentId({
                parentId: 0,
                parentOptId: 0
            });

            list.push(
                ...pddGoodsCategoryList.map(item => ({
                    ...item,
                    parentId: -1
                }))
            );

            let selfItem = {
                id: 0,
                optId: 0,
                name: nav?.selfRun,
                isSelf: true,
                icon: "",
                iconActive: "",
                parentId: -1
            };

            if (hasSelfCategory) {
                selfItem.hasSelf = true;
            } else {
                selfItem.hasSelf = false;
            }
            list = [selfItem, ...list].slice(0, 9);

            f(setGoodsCategoryList(list));
            f(setHasSelf(hasSelfCategory));
        } catch (error) {
        } finally {
        }
    };
};

// 类别类型
export const setCategoryType = payload => {
    return {
        type: type.SET_CATEGORY_TYPE,
        payload
    };
};

// 是否有自营
export const setHasSelf = payload => {
    return {
        type: type.SET_HAS_SELF,
        payload
    };
};

// 菜单类型
export const setMenuType = payload => {
    return {
        type: type.SET_MENU_TYPE,
        payload
    };
};
